module.exports = __webpack_public_path__ + "static/img/logo.8730d3cf.png";